import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ShopLoginPage from '../components/ShopAuth/ShopLoginPage';
import ShopSignupPage from '../components/ShopAuth/ShopSignupPage';
import ShopForgotPasswordPage from '../components/ShopAuth/ShopForgotPasswordPage';
import ShopDashboardPage from '../components/ShopDashboardPage';
import ShopEstimateAccessPage from '../components/ShopEstimateAccessPage';
import DiagnosticReportPage from '../components/DiagnosticReportPage';
import PartnerShell from '../components/Partner/PartnerShell';
import ShopSettingsPage from '../components/Partner/ShopSettingsPage';
import ShopCalendarPage from '../components/Partner/ShopCalendarPage';
import ShopNotificationsPage from '../components/Partner/ShopNotificationsPage';

export default function PartnerApp() {
    return (
        <Routes>
            <Route path="/login" element={<ShopLoginPage />} />
            <Route path="/signup" element={<ShopSignupPage />} />
            <Route path="/forgot-password" element={<ShopForgotPasswordPage />} />

            {/* Token is the authorisation — no shop session required. */}
            <Route path="/shop/estimate/:token" element={<ShopEstimateAccessPage />} />

            <Route element={<PartnerShell />}>
                <Route path="/" element={<ShopDashboardPage />} />
                <Route path="/calendar" element={<ShopCalendarPage />} />
                <Route path="/notifications" element={<ShopNotificationsPage />} />
                <Route path="/settings" element={<ShopSettingsPage />} />
                <Route path="/diagnostic-report/:reportId" element={<DiagnosticReportPage />} />
            </Route>

            <Route path="/shop" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
